/* eslint-disable import/prefer-default-export */
import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

/**
 * GET Bancos
 * @param {Object} params
 * @returns {Promise<Array<Object>>}
 */
export const getBancos = async (params = null) => {
  try {
    const response = await API.get('configuracion/bancos/', { params });
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * GET Banco
 * @param {number} id
 * @returns {Promise<Array<Object>>}
 */
export const getBanco = async (id) => {
  try {
    const response = await API.get(`configuracion/bancos/${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Banco
 * @param {object} values
 * @returns {Promise<Array<Object>>}
 */
export const postBanco = async (values) => {
  try {
    const response = await API.get('configuracion/bancos/', values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * PATCH Banco
 * @param {number} id
 * @param {object} values
 * @returns {Promise<Array<Object>>}
 */
export const patchBanco = async (id, values) => {
  try {
    const response = await API.get(`configuracion/bancos/${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * DELETE Banco
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteBanco = async (id) => {
  try {
    const response = await API.get(`configuracion/bancos/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
